module.exports = __webpack_public_path__ + "assets/img/rim-bambino.b0bf5a48.png";